import { render } from "./ListaSaidas.vue?vue&type=template&id=0ed34b4e"
import script from "./ListaSaidas.vue?vue&type=script&lang=js"
export * from "./ListaSaidas.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__